<template>
  <div>
    <Highlight />
    <div class="contents">
      <div class="contents__inner">
        <div class="homeContents">
          <Articles />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highlight from "../components/Highlight.vue";
import Articles from "../components/Articles.vue";

import { getUpdateInfo } from "../functions/update-info-function";
import { getAllArticles } from "../functions/articles-function";

export default {
  name: "home",
  data() {
    return {
      news: [],
      info: []
    };
  },
  components: {
    Highlight,
    Articles
  },
  methods: {
    getUpdateInfo: async function() {
      this.news = await getAllArticles();
      this.info = await getUpdateInfo();
    }
  },
  metaInfo() {
    return {
      title: `Island State Music`,
      meta: [
        { property: "og:title", content: "Island State Music Home" },
        { property: "og:site_name", content: "Island State Music Home" },
        {
          property: "og:description",
          content:
            "Island State Musicは日本の音楽レーベル。Harada Kosukeが設立し、Shurkn Pap, MALIYA, Kohjiyaが所属している。"
        },
        { property: "og:type", content: "home" },
        {
          property: "og:url",
          content: "https://islandstatemusic.com"
        },
        {
          property: "og:image",
          content: "../assets/logo/IslandStateMusic.svg"
        }
      ]
    };
  },
  mounted: function() {
    this.getUpdateInfo();
  }
};
</script>

<style lang="scss" scoped>
.contents {
  margin-top: 30px;

  &__inner {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }
}
.headline {
  color: silver;
  background-color: #0c0c0c;
}

.homeContents {
  &__item {
    padding: 20px 50px 30px 50px;
    border-bottom: 1px solid #143d73;
  }

  &__img {
    img {
      width: 100%;
    }
  }

  &__video {
    width: 95%;
    height: 400px;
  }
}

a {
  text-decoration: none;
  color: silver;
}

a:hover {
  color: blue;
}
</style>
